export enum SowSubmissionStatusEnum {
	FullSubmissionRequired = 1,
	AdditionalDocumentsRequired = 2,
	DocumentsAlreadySubmitted = 3,
	NoActiveSOWRequests = 4,
	ErrorFetching = 5,
}

export enum InputTypeEnum {
	Text = "text",
	Date = "date",
	CheckboxOnly = "checkbox",
	CheckboxCustomOne = "checkbox-custom-one",
	CheckboxCustomMultiple = "checkbox-custom-multiple",
}

export enum MultiSelectOptionType {
	Text = "text",
	Checkbox = "checkbox",
}
